import React, {useState} from 'react';

import { Form, Button, Row, Col, ListGroup, Table, ButtonGroup } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import ImageUploading from 'react-images-uploading';

import ToggleButton from 'react-bootstrap/ToggleButton'


import Rightbar from './Rightbar';

export default function UpdateArtWork(){ 
const [radioValue, setRadioValue] = useState('1');

const radios = [
{ name: 'INCHES', value: '1' },
{ name: 'CENTIMETERS', value: '2' }
];
const [images, setImages] = React.useState([]);
const maxNumber = 69;

const onChange = (imageList, addUpdateIndex) => {
// data for submit
console.log(imageList, addUpdateIndex);
setImages(imageList);
};
const [sidebar, setsidebar] = useState(false);
const [mainbar, setmainbar] = useState(false);
const toggle = () => {
setsidebar(!sidebar);
setmainbar(!mainbar);
}
return(
<>
<section className="sec-container" >
<div className='container'>
<div className='portalevent'>
<div className='row'>
<div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
<div >
<Rightbar/>
</div>
</div>
<div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
<div className='rightbar '>
<Button variant="outline-info" onClick={toggle}>
<FontAwesomeIcon icon={faAlignLeft} />
</Button>
<div className='add-post'>
<h1>GALLERY LANDING PAGE</h1>
<div className='gry-bg'>
<p>
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor 
incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud 
exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure 
dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. 
Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt 
mollit anim id est laborum
</p>
</div>


<div className='row'>      
<div className='col-md-12 col-12'>
<Form>
<Row>
<Col>
<Form.Group  controlId="formHorizontalEmail">
<Form.Label > About the gallery  <span className='star'>*</span></Form.Label>
<Form.Control as="textarea" rows={3} />
</Form.Group>
<Form.Group controlId="formHorizontalEmail">
<Form.Label > Direct Purchase Link (Artsy,gallery website, etc.)</Form.Label>
<Form.Control type="text" placeholder="Direct Purchase" />
</Form.Group>
<Form.Group  controlId="formHorizontalEmail">
<Form.Label > Gallery Video (optional)  </Form.Label>
<i>Videos must be hosted on a third party platform (Vimeo, YouTube, etc.). </i>
<Form.Control type="text" placeholder="Video Link" />
</Form.Group>
</Col>
<Col>
<Form.Group className='gallerylanding'>
<Form.Label >Lading Page name </Form.Label>
<p>File Specifications: jpg, sRGB, 72 dpi, 
File names cannot contain any apostro</p>

<ImageUploading
value={images}
onChange={onChange}
maxNumber={maxNumber}
dataURLKey="data_url"
>
{({
imageList,
onImageUpload,
onImageRemoveAll,
onImageUpdate,
onImageRemove,
isDragging,
dragProps,
}) => (
// write your building UI
<div className="choose-file">
<button type='button'
style={isDragging ? { color: 'red' } : undefined}
onClick={onImageUpload}
{...dragProps}
>
<img src={process.env.PUBLIC_URL+'/images/crop-image.png'}/>
</button>

{imageList.map((image, index) => (
<div key={index} className="image-item">
<img src={image['data_url']} alt="" width="100" />
<div className="image-item__btn-wrapper">
<button type='button' onClick={() => onImageUpdate(index)}>Update</button>
<button type='button' onClick={() => onImageRemove(index)}>Remove</button>
</div>
</div>
))}
</div>
)}
</ImageUploading>
</Form.Group>
</Col>
</Row>

<Row >                                    
<Form.Label>Artist</Form.Label>
<Col>
<Form.Group controlId="validationCustom01">
<Form.Control
required
type="text"
placeholder="First name"
/>
</Form.Group>
</Col>
<Col>
<Form.Group controlId="validationCustom02">
<Form.Control
required
type="text"
placeholder="Last name"
/>
</Form.Group>
</Col>
</Row>

<Row >                                    
<Form.Label>Artist</Form.Label>
<Col>
<Form.Group controlId="validationCustom01">
<Form.Control
required
type="text"
placeholder="First name"
/>
</Form.Group>
</Col>
<Col>
<Form.Group controlId="validationCustom02">
<Form.Control
required
type="text"
placeholder="Last name"
/>
</Form.Group>
</Col>
</Row>
<Row >                                    
<Form.Label>Artist</Form.Label>
<Col>
<Form.Group controlId="validationCustom01">
<Form.Control
required
type="text"
placeholder="First name"
/>
</Form.Group>
</Col>
<Col>
<Form.Group controlId="validationCustom02">
<Form.Control
required
type="text"
placeholder="Last name"
/>
</Form.Group>
</Col>
</Row>

<Row >                                    
<Form.Label>Artist</Form.Label>
<Col>
<Form.Group controlId="validationCustom01">
<Form.Control
required
type="text"
placeholder="First name"
/>
</Form.Group>
</Col>
<Col>
<Form.Group controlId="validationCustom02">
<Form.Control
required
type="text"
placeholder="Last name"
/>
</Form.Group>
</Col>
</Row>
<br/>
<div className='text-center'>
<Button className='common-btn'>Add Another artist</Button>
</div>


</Form>
</div>

</div> <hr/>
<div className='text-center'>
<Button className='common-btn'>SAVE</Button>{' '}
<Button className='cancel-btn'>CANCEL</Button>{' '}
</div>
<br/>
</div>
</div>
</div>
</div>
</div>
</div>
</section>  


</>
)
}
